import { FontStatus } from 'editor/src/store/fonts/types';
import { RootState } from 'editor/src/store/index';

import getFontDefinition from './getFontDefinition';

const isFontLoaded = (state: RootState, fontFile: string) =>
  getFontDefinition(state, fontFile)?.status === FontStatus.ready;

export default isFontLoaded;
